import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import '../components/style/global.css';
import Home from './pages/Home';
import Header from './Header';
import Footer from './Footer';
import About from './pages/About';
import MovieProfile from './pages/MovieProfile';
import Movies from './pages/Movies';
import HitchcockCollection from './pages/Hitchcock';
import Community from './pages/Community.js';
import Submit from './pages/Submit';
import PitchDeck from './pages/PitchDeck.js';
import { Provider } from 'react-redux';
import store from './utils/store.js';
import Login from './pages/Login.js';
import SignUp from './pages/signUp.js';
import Studios from "./pages/Studios";
import Contact from "./pages/Contact";
import PrivacyTOS from './pages/PrivacyTOS.js';
import ResetPassword from './pages/passwordReset.js';
import PrivateRoute from "./utils/PrivateRoute";

//Test
import HomeTest from './pages/HomeTest';
import MovieProfileTest from './pages/MovieProfileTest';
import CrewProfile from './pages/crewProfile';
import SiteDirectory from './pages/siteDirectory';
import { AuthProvider } from '../components/utils/AuthContext.js'; 



function WebsiteContainer() {
  const [currentPage, setCurrentPage] = useState('Home');
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  return (
    <div className="app-container">
      <AuthProvider> 
      <Provider store={store}>
      {!showVideoPlayer && (
            <Header currentPage={currentPage} handlePageChange={setCurrentPage} />
          )}
      <div className="page-content-margin">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Studios" element={<Studios />} />
        {/* <Route path="/Contact" element={<Contact />} /> */}
        <Route path="/:moviename" element={<MovieProfile setShowVideoPlayer={setShowVideoPlayer}  />} />
        <Route path="/Movies/:moviename" element={<Movies />} />
        <Route path="/HitchcockCollection" element={<HitchcockCollection />} />
        {/* <Route path="/Community" element={<PrivateRoute><Community /></PrivateRoute>} /> */}
        <Route path="/PitchPage" element={<PrivateRoute><PitchDeck /></PrivateRoute>} />
        {/* <Route path="/Submit" element={<Submit />} /> */}
        <Route path="/Login" element={<Login />} />
        <Route path="/SignUp" element={<SignUp/>} />
        <Route path="/Privacy" element={<PrivacyTOS/>} />
        <Route path="/ResetPassword/:token" element={<ResetPassword/>} />

        
        {/* <Route path="/HomeTest" element={<PrivateRoute><HomeTest /></PrivateRoute>} /> */}
        <Route path="/test/:moviename" element={<PrivateRoute><MovieProfileTest  setShowVideoPlayer={setShowVideoPlayer}  /></PrivateRoute>} />
        <Route path="/crewProfile/:userId" element={<PrivateRoute><CrewProfile/></PrivateRoute>} /> 
        <Route path="/TFDirect" element={<PrivateRoute><SiteDirectory/></PrivateRoute>} /> 
      </Routes>
      </div>
      {!showVideoPlayer && (
            <Footer currentPage={currentPage} handlePageChange={setCurrentPage} />
          )}
      </Provider>
      </AuthProvider>
    </div>
    
  );
}

export default WebsiteContainer;
